import { render, staticRenderFns } from "./statisticsCard.vue?vue&type=template&id=b64b68cc&scoped=true"
import script from "./statisticsCard.vue?vue&type=script&lang=js"
export * from "./statisticsCard.vue?vue&type=script&lang=js"
import style0 from "./statisticsCard.vue?vue&type=style&index=0&id=b64b68cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64b68cc",
  null
  
)

export default component.exports